export default __webpack_public_path__ + "static/media/ies_PagoIluminare_ENG.abc8ae92.png";